import { useSyncExternalStore } from 'react';
import { subscribeSaveStatus, getSaveStatus } from '../utils/saveStatusUtils';

// 'idle' | 'saving' | 'saved' | 'error' — driven by the tripUtils save wrappers
export function useSaveStatus() {
    return useSyncExternalStore(subscribeSaveStatus, getSaveStatus);
}
